module.exports = __webpack_public_path__ + "static/media/Img-banner-Premio-Ebit-03.3de536be.3de536be.png";